import { render, staticRenderFns } from "./DistributeOrganization.vue?vue&type=template&id=9b6c6fb8&scoped=true"
import script from "./DistributeOrganization.vue?vue&type=script&lang=js"
export * from "./DistributeOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6c6fb8",
  null
  
)

export default component.exports